import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: ReactNode;
  adminOnly?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // If admin access is required but user is not admin, redirect to their application
  if (adminOnly && user && !user.is_admin) {
  return <Navigate to="/student-pathway" />;
  }

  // If user is not admin and trying to access admin routes, redirect to their application
  if (user && !user.is_admin && window.location.pathname.startsWith('/admin')) {
    return <Navigate to="/student-pathway" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
